import { crmFetch } from '../chat/api'

/**
 * Saves a fan's name on OnlyFans the way fan-rename.js saveFanCustomNameRemote
 * does: the gateway's rename-fan, then OnlyFans' own chat and user endpoints.
 */
export async function renameFanOnOnlyFans(accountId: string, fanId: string, name: string): Promise<void> {
  try {
    await crmFetch('/v1/users/rename-fan', { accountId, body: { fan_id: fanId, display_name: name } })
    return
  } catch {
    /* OnlyFans' own endpoints below */
  }
  const referer = `https://onlyfans.com/my/chats/chat/${fanId}/`
  const attempts = [
    { method: 'PUT', api_path: `/api2/v2/chats/${fanId}`, body: { customName: name || null }, referer },
    { method: 'PUT', api_path: `/api2/v2/users/${fanId}/display-name`, body: { name: name || null }, referer },
  ]
  let last: unknown = null
  for (const attempt of attempts) {
    try {
      await crmFetch('/v1/of/raw', { accountId, body: attempt })
      return
    } catch (err) {
      last = err
    }
  }
  throw last
}
